import {useCallback} from "react";
import {useDispatch} from "react-redux";
import {message, notification} from "antd";
import {deletePortfolios} from "../../api/portfolioApi";


const usePortfolioGroupActions = ()=>{
    const dispatch = useDispatch();

    const handleDelete = useCallback((selectedKeys) => {
      if (!selectedKeys?.length) {
        return message.error("No portfolios selected to remove");
      }

      return dispatch(deletePortfolios({ portfolioIds: selectedKeys }))
        .then(() => {
          notification.success({
            message: 'Portfolios Removed',
            description: 'Portfolios successfully removed'
          });
          return true; // Signal success to parent
        })
        .catch((error) => {
          message.error(`An error occurred while removing portfolios. ${error}`);
          return false;
        });
    }, [dispatch]);


    return {
        handleDelete
    }
}

export default usePortfolioGroupActions;